import { render, staticRenderFns } from "./bestseller.vue?vue&type=template&id=30489cb0&scoped=true"
import script from "./bestseller.vue?vue&type=script&lang=js"
export * from "./bestseller.vue?vue&type=script&lang=js"
import style0 from "./bestseller.vue?vue&type=style&index=0&id=30489cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30489cb0",
  null
  
)

export default component.exports